import { Navigate } from "react-router-dom";
// import { useAuthValue } from "./AuthContext";

export default function PrivateRoute({ children }) {
  // const { user, loading } = useAuthValue();
  // console.log(`private route user`);
  // console.log(children.props);
  // console.log(loading);
  // console.log(error);
  if (children.props.user === null && children.props.loading === false) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
